import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { getPersistedMirrordRoute } from 'common/environments';
import { App } from './app';
import './index.css';

// Expose the mirrord route to the League SDK so it injects
// X-League-Mirrord-Route on every request (MSP3-9).
// Resolved from localStorage (environment switcher) or VITE_MIRRORD_ROUTE.
window.getMirrordRoute = () => {
  const route = getPersistedMirrordRoute();
  return route || undefined;
};

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
